/**
 * /tenants/$slug/users — list route shim.
 */

import { createFileRoute } from "@tanstack/react-router";
import {
  usersListSearchSchema,
  type UsersListSearch,
} from "@/features/users/schemas";
import { fetchUsersList } from "@/features/users/queries";
import { queryKeys } from "@/lib/query-keys";
import { UsersListPage } from "@/features/users/pages/users-list-page";

export const Route = createFileRoute("/_authed/tenants/$slug/users/")({
  validateSearch: (raw: Record<string, unknown>): UsersListSearch =>
    usersListSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.users.list(context.tenant.id, deps.search),
      queryFn: () => fetchUsersList(context.tenant.id, deps.search),
    }),
  component: UsersListPage,
});
